import { useScheduleEditorIds } from "./use-schedule-editor-ids"
import { readScheduleEditorSession } from "../lib/schedule-editor-session"

/** Published vs original task lists for task comparison UI. Static after initial load. */
export function useScheduleEditorCompareTasks() {
    const { draftId } = useScheduleEditorIds()
    const session = readScheduleEditorSession(draftId)

    return {
        originalTasks: session?.originalTasks ?? [],
        publishedTasks: session?.publishedTasks ?? [],
    }
}
